import { render, staticRenderFns } from "./WAuthorSelect.vue?vue&type=template&id=086b6ae8&"
import script from "./WAuthorSelect.vue?vue&type=script&lang=js&"
export * from "./WAuthorSelect.vue?vue&type=script&lang=js&"
import style0 from "./WAuthorSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports